import ProgrammingBug from '@streamlinehq/streamlinehq/img/streamline-mini-line/programming/bugs/programming-bug.svg';
import { useState } from 'react';
import styled from 'styled-components';
import { BouTextAndIcon } from '../../../../../../../generic/components/bou-text-and-icon';
import { BouColor } from '../../../../../../../generic/global/bou-colors';
import { useGetLoggedInUser } from '../../../../../../../generic/hooks';
import { LoginToSuggestFixesModal } from '@upright/ui/common/generic/modals/login-to-suggest-fixes-modal';
import { useImpactChartContext, useImpactChartFontSizes } from '../../context';

export function SuggestFixes() {
  const { onContributeClick } = useImpactChartContext();
  const [notAvailableModalOpen, setNotAvailableModalOpen] = useState(false);
  const { actionText: fontSize } = useImpactChartFontSizes();
  const canSuggest = useGetLoggedInUser() !== undefined;
  return (
    <>
      <TextAndIcon
        onClick={
          canSuggest
            ? onContributeClick
            : () => {
                setNotAvailableModalOpen(true);
              }
        }
        text="Suggest fixes"
        slIcon={<ProgrammingBug />}
        style={{ fontSize, marginTop: '1.0em', cursor: 'pointer' }}
      />
      <LoginToSuggestFixesModal modalOpen={notAvailableModalOpen} setModalOpen={setNotAvailableModalOpen} />
    </>
  );
}

const TextAndIcon = styled(BouTextAndIcon)`
  &:hover {
    color: ${BouColor.GREY_B3B3B3};
  }
`;
